import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Switch, Route } from 'react-router';
import configureStore, { history } from '@app/store';

import 'core-js/features/promise';
import 'core-js/features/set';

import App from '@app/App';

import '@scss/index.scss';
import { ConnectedRouter } from 'connected-react-router';
import { initSentry } from '@app/helpers/initSentry';

const store = configureStore();

const Root = () => {
  initSentry();

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <>
          <Switch>
            <Route exact path="/*" render={() => <App />} />
          </Switch>
        </>
      </ConnectedRouter>
    </Provider>
  );
};

render(<Root />, document.getElementById('root'));
